import { render, staticRenderFns } from "./PaymentTransactionEventForm.vue?vue&type=template&id=34792a03&"
import script from "./PaymentTransactionEventForm.vue?vue&type=script&lang=js&"
export * from "./PaymentTransactionEventForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports